/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RecipientProviderStatus } from './RecipientProviderStatus';
import {
    RecipientProviderStatusFromJSON,
    RecipientProviderStatusFromJSONTyped,
    RecipientProviderStatusToJSON,
} from './RecipientProviderStatus';

/**
 * 
 * @export
 * @interface AllowedRecipientFacility
 */
export interface AllowedRecipientFacility {
    /**
     * 
     * @type {number}
     * @memberof AllowedRecipientFacility
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AllowedRecipientFacility
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AllowedRecipientFacility
     */
    facility_type: string;
    /**
     * 
     * @type {string}
     * @memberof AllowedRecipientFacility
     */
    address: string;
    /**
     * 
     * @type {number}
     * @memberof AllowedRecipientFacility
     */
    organization_id: number;
    /**
     * 
     * @type {string}
     * @memberof AllowedRecipientFacility
     */
    provider_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AllowedRecipientFacility
     */
    email?: string;
    /**
     * Optional branded label overriding the generic facility-type label in the recipient picker (e.g. "Dialyze Direct").
     * @type {string}
     * @memberof AllowedRecipientFacility
     */
    display_name?: string;
    /**
     * 
     * @type {RecipientProviderStatus}
     * @memberof AllowedRecipientFacility
     */
    provider_status?: RecipientProviderStatus;
    /**
     * 
     * @type {string}
     * @memberof AllowedRecipientFacility
     */
    ccn?: string;
}

/**
 * Check if a given object implements the AllowedRecipientFacility interface.
 */
export function instanceOfAllowedRecipientFacility(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "facility_type" in value;
    isInstance = isInstance && "address" in value;
    isInstance = isInstance && "organization_id" in value;

    return isInstance;
}

export function AllowedRecipientFacilityFromJSON(json: any): AllowedRecipientFacility {
    return AllowedRecipientFacilityFromJSONTyped(json, false);
}

export function AllowedRecipientFacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllowedRecipientFacility {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'facility_type': json['facility_type'],
        'address': json['address'],
        'organization_id': json['organization_id'],
        'provider_id': !exists(json, 'provider_id') ? undefined : json['provider_id'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'display_name': !exists(json, 'display_name') ? undefined : json['display_name'],
        'provider_status': !exists(json, 'provider_status') ? undefined : RecipientProviderStatusFromJSON(json['provider_status']),
        'ccn': !exists(json, 'ccn') ? undefined : json['ccn'],
    };
}

export function AllowedRecipientFacilityToJSON(value?: AllowedRecipientFacility | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'facility_type': value.facility_type,
        'address': value.address,
        'organization_id': value.organization_id,
        'provider_id': value.provider_id,
        'email': value.email,
        'display_name': value.display_name,
        'provider_status': RecipientProviderStatusToJSON(value.provider_status),
        'ccn': value.ccn,
    };
}

